import React, { createContext } from 'react';

import { usePersistedState } from 'hooks/PersistedState';
import PropTypes from 'prop-types';

export const ParticipantsListContext = createContext({});

export const ParticipantsListContextProvider = ({ children }) => {
  const [list, setList] = usePersistedState('showList', false);

  return (
    // it's a custom hook to save thins in the local storage, not much we can do about it
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ParticipantsListContext.Provider value={{ list, setList }}>
      {children}
    </ParticipantsListContext.Provider>
  );
};
ParticipantsListContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
